/**
 * Deletes multiple search parameters from a given searchParams string.
 *
 * @param {string[]} paramsToDelete - An array of parameter names to delete.
 * @param {string} searchParamsString - The search parameters string to modify.
 * @returns {string} The modified search parameters string with the specified parameters removed.
 */
export const deleteMultipleSearchParams = (paramsToDelete, searchParamsString) => {
  const searchParams = new URLSearchParams(searchParamsString);

  paramsToDelete.forEach((param) => searchParams.delete(param));

  return searchParams.toString(); // Return the modified searchParams string
};
